<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7545_7478)">
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint0_linear_7545_7478)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint1_linear_7545_7478)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint2_linear_7545_7478)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint3_linear_7545_7478)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint4_linear_7545_7478)"
      />
      <path d="M20.4148 2.33586C20.2272 2.14833 19.9729 2.04297 19.7077 2.04297H6.43906C5.66586 2.04297 5.03906 2.66977 5.03906 3.44296V28.557C5.03906 29.3302 5.66586 29.957 6.43906 29.957H25.5609C26.3341 29.957 26.9609 29.3302 26.9609 28.557V9.29623C26.9609 9.03102 26.8556 8.77666 26.668 8.58913L20.4148 2.33586Z"
            fill="url(#paint5_linear_7545_7478)"
      />
      <path d="M18.387 2.3967C18.387 2.1953 18.456 2.06667 18.3252 2.04514C18.4495 2.05178 18.6121 2.00749 18.7265 2.04513C19.8242 2.04514 19.8536 2.02313 19.9687 2.11734C20.1601 2.16031 20.0602 2.37381 20.0636 2.37661L26.2969 9.47909C26.3197 9.49816 26.3414 9.51791 26.3621 9.5383C26.464 9.63865 26.5406 9.7543 26.5885 9.87825C26.6266 9.97683 26.6465 10.0807 26.6465 10.1862V10.2493C26.6465 10.0171 26.446 9.87825 26.2969 9.87825H19.8189C19.0281 9.87825 18.387 8.50007 18.387 7.83733V2.3967Z"
            fill="url(#paint6_radial_7545_7478)"
      />
      <path d="M18.387 2.3967C18.387 2.1953 18.456 2.06667 18.3252 2.04514C18.4495 2.05178 18.6121 2.00749 18.7265 2.04513C19.8242 2.04514 19.8536 2.02313 19.9687 2.11734C20.1601 2.16031 20.0602 2.37381 20.0636 2.37661L26.2969 9.47909C26.3197 9.49816 26.3414 9.51791 26.3621 9.5383C26.464 9.63865 26.5406 9.7543 26.5885 9.87825C26.6266 9.97683 26.6465 10.0807 26.6465 10.1862V10.2493C26.6465 10.0171 26.446 9.87825 26.2969 9.87825H19.8189C19.0281 9.87825 18.387 8.50007 18.387 7.83733V2.3967Z"
            fill="url(#paint7_radial_7545_7478)"
      />
      <path d="M18.387 2.3967C18.387 2.1953 18.456 2.06667 18.3252 2.04514C18.4495 2.05178 18.6121 2.00749 18.7265 2.04513C19.8242 2.04514 19.8536 2.02313 19.9687 2.11734C20.1601 2.16031 20.0602 2.37381 20.0636 2.37661L26.2969 9.47909C26.3197 9.49816 26.3414 9.51791 26.3621 9.5383C26.464 9.63865 26.5406 9.7543 26.5885 9.87825C26.6266 9.97683 26.6465 10.0807 26.6465 10.1862V10.2493C26.6465 10.0171 26.446 9.87825 26.2969 9.87825H19.8189C19.0281 9.87825 18.387 8.50007 18.387 7.83733V2.3967Z"
            fill="url(#paint8_radial_7545_7478)"
      />
      <path d="M18.387 2.3967C18.387 2.1953 18.456 2.06667 18.3252 2.04514C18.4495 2.05178 18.6121 2.00749 18.7265 2.04513C19.8242 2.04514 19.8536 2.02313 19.9687 2.11734C20.1601 2.16031 20.0602 2.37381 20.0636 2.37661L26.2969 9.47909C26.3197 9.49816 26.3414 9.51791 26.3621 9.5383C26.464 9.63865 26.5406 9.7543 26.5885 9.87825C26.6266 9.97683 26.6465 10.0807 26.6465 10.1862V10.2493C26.6465 10.0171 26.446 9.87825 26.2969 9.87825H19.8189C19.0281 9.87825 18.387 8.50007 18.387 7.83733V2.3967Z"
            fill="url(#paint9_radial_7545_7478)"
      />
      <path d="M18.387 2.3967C18.387 2.1953 18.456 2.06667 18.3252 2.04514C18.4495 2.05178 18.6121 2.00749 18.7265 2.04513C19.8242 2.04514 19.8536 2.02313 19.9687 2.11734C20.1601 2.16031 20.0602 2.37381 20.0636 2.37661L26.2969 9.47909C26.3197 9.49816 26.3414 9.51791 26.3621 9.5383C26.464 9.63865 26.5406 9.7543 26.5885 9.87825C26.6266 9.97683 26.6465 10.0807 26.6465 10.1862V10.2493C26.6465 10.0171 26.446 9.87825 26.2969 9.87825H19.8189C19.0281 9.87825 18.387 8.50007 18.387 7.83733V2.3967Z"
            fill="url(#paint10_radial_7545_7478)"
      />
      <path d="M18.387 2.3967C18.387 2.1953 18.456 2.06667 18.3252 2.04514C18.4495 2.05178 18.6121 2.00749 18.7265 2.04513C19.8242 2.04514 19.8536 2.02313 19.9687 2.11734C20.1601 2.16031 20.0602 2.37381 20.0636 2.37661L26.2969 9.47909C26.3197 9.49816 26.3414 9.51791 26.3621 9.5383C26.464 9.63865 26.5406 9.7543 26.5885 9.87825C26.6266 9.97683 26.6465 10.0807 26.6465 10.1862V10.2493C26.6465 10.0171 26.446 9.87825 26.2969 9.87825H19.8189C19.0281 9.87825 18.387 8.50007 18.387 7.83733V2.3967Z"
            fill="url(#paint11_radial_7545_7478)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint12_linear_7545_7478)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint13_linear_7545_7478)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint14_linear_7545_7478)"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint15_radial_7545_7478)"
            fill-opacity="0.8"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint16_radial_7545_7478)"
            fill-opacity="0.8"
      />
      <path d="M20.0391 2.34758C20.0391 2.14618 19.8811 2.06645 19.7715 2.04492C19.8756 2.05156 19.9774 2.07442 20.0732 2.11206C20.1965 2.16045 20.31 2.23328 20.4065 2.32748C20.4093 2.33023 20.4121 2.33299 20.4149 2.33578L26.6681 8.58905C26.6872 8.60812 26.7054 8.62787 26.7227 8.64825C26.8081 8.7486 26.8723 8.86426 26.9124 8.9882C26.9443 9.08678 26.961 9.19061 26.961 9.29616V9.3593C26.961 9.1271 26.793 8.9882 26.6681 8.9882H21.2391C20.5764 8.9882 20.0391 8.45094 20.0391 7.78821V2.34758Z"
            fill="url(#paint17_linear_7545_7478)"
      />
      <path d="M17.5273 20.9961C17.8013 20.9961 18.0234 21.2182 18.0234 21.4922C18.0234 21.7662 17.8013 21.9883 17.5273 21.9883H9.53516C9.26117 21.9883 9.03906 21.7662 9.03906 21.4922C9.03906 21.2182 9.26117 20.9961 9.53516 20.9961H17.5273ZM22.457 17.9961C22.731 17.9961 22.9531 18.2182 22.9531 18.4922C22.9531 18.7662 22.731 18.9883 22.457 18.9883H9.53516C9.26117 18.9883 9.03906 18.7662 9.03906 18.4922C9.03906 18.2182 9.26117 17.9961 9.53516 17.9961H22.457ZM22.457 14.9961C22.731 14.9961 22.9531 15.2182 22.9531 15.4922C22.9531 15.7662 22.731 15.9883 22.457 15.9883H9.53516C9.26117 15.9883 9.03906 15.7662 9.03906 15.4922C9.03906 15.2182 9.26117 14.9961 9.53516 14.9961H22.457ZM22.457 11.9961C22.731 11.9961 22.9531 12.2182 22.9531 12.4922C22.9531 12.7662 22.731 12.9883 22.457 12.9883H9.53516C9.26117 12.9883 9.03906 12.7662 9.03906 12.4922C9.03906 12.2182 9.26117 11.9961 9.53516 11.9961H22.457Z"
            fill="url(#paint18_linear_7545_7478)"
      />
      <path d="M25.0732 13.4982C25.7137 12.9728 26.6588 13.0661 27.1843 13.7066L29.1349 16.0844C29.6603 16.7248 29.567 17.67 28.9265 18.1954L14.7887 29.7934L10.9354 25.0962L25.0732 13.4982Z"
            fill="url(#paint19_radial_7545_7478)"
      />
      <path d="M25.0732 13.4982C25.7137 12.9728 26.6588 13.0661 27.1843 13.7066L29.1349 16.0844C29.6603 16.7248 29.567 17.67 28.9265 18.1954L14.7887 29.7934L10.9354 25.0962L25.0732 13.4982Z"
            fill="url(#paint20_linear_7545_7478)"
      />
      <path d="M25.0732 13.4982C25.7137 12.9728 26.6588 13.0661 27.1843 13.7066L29.1349 16.0844C29.6603 16.7248 29.567 17.67 28.9265 18.1954L14.7887 29.7934L10.9354 25.0962L25.0732 13.4982Z"
            fill="url(#paint21_linear_7545_7478)"
      />
      <path d="M25.0732 13.4982C25.7137 12.9728 26.6588 13.0661 27.1843 13.7066L29.1349 16.0844C29.6603 16.7248 29.567 17.67 28.9265 18.1954L14.7887 29.7934L10.9354 25.0962L25.0732 13.4982Z"
            fill="url(#paint22_radial_7545_7478)"
      />
      <path d="M9.84263 29.7944C9.82669 29.8761 9.88912 29.952 9.97235 29.9522L14.3259 29.9633C14.4512 29.9636 14.574 29.9284 14.6801 29.8617L14.7888 29.7934L10.9355 25.0962L10.8613 25.17C10.7672 25.2634 10.7034 25.3829 10.678 25.5131L9.84263 29.7944Z"
            fill="url(#paint23_linear_7545_7478)"
      />
      <path d="M9.84263 29.7944C9.82669 29.8761 9.88912 29.952 9.97235 29.9522L14.3259 29.9633C14.4512 29.9636 14.574 29.9284 14.6801 29.8617L14.7888 29.7934L10.9355 25.0962L10.8613 25.17C10.7672 25.2634 10.7034 25.3829 10.678 25.5131L9.84263 29.7944Z"
            fill="url(#paint24_linear_7545_7478)"
      />
      <path d="M9.84263 29.7944C9.82669 29.8761 9.88912 29.952 9.97235 29.9522L14.3259 29.9633C14.4512 29.9636 14.574 29.9284 14.6801 29.8617L14.7888 29.7934L10.9355 25.0962L10.8613 25.17C10.7672 25.2634 10.7034 25.3829 10.678 25.5131L9.84263 29.7944Z"
            fill="url(#paint25_linear_7545_7478)"
      />
      <path d="M27.0132 19.7652L29.3179 17.8745C29.7422 17.5264 29.804 16.9002 29.4559 16.4759L26.8632 13.3154C26.5151 12.891 25.8889 12.8292 25.4645 13.1773L23.1599 15.068L27.0132 19.7652Z"
            fill="url(#paint26_linear_7545_7478)"
      />
      <path d="M27.0132 19.7652L29.3179 17.8745C29.7422 17.5264 29.804 16.9002 29.4559 16.4759L26.8632 13.3154C26.5151 12.891 25.8889 12.8292 25.4645 13.1773L23.1599 15.068L27.0132 19.7652Z"
            fill="url(#paint27_linear_7545_7478)"
      />
      <path d="M27.0132 19.7652L29.3179 17.8745C29.7422 17.5264 29.804 16.9002 29.4559 16.4759L26.8632 13.3154C26.5151 12.891 25.8889 12.8292 25.4645 13.1773L23.1599 15.068L27.0132 19.7652Z"
            fill="url(#paint28_radial_7545_7478)"
      />
      <path d="M20.8493 16.9634L23.1599 15.0679L27.0132 19.7651L24.7027 21.6605L20.8493 16.9634Z"
            fill="url(#paint29_linear_7545_7478)"
      />
      <path d="M20.8493 16.9634L23.1599 15.0679L27.0132 19.7651L24.7027 21.6605L20.8493 16.9634Z"
            fill="url(#paint30_linear_7545_7478)"
      />
      <path d="M9.97241 29.9523C9.88917 29.9521 9.82674 29.8761 9.84268 29.7944L10.1357 28.2925L11.5005 29.9561L9.97241 29.9523Z"
            fill="url(#paint31_linear_7545_7478)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7545_7478"
                      x1="16"
                      y1="2.04297"
                      x2="16"
                      y2="30.883"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E4DCEA" />
        <stop offset="1"
              stop-color="#CEC1D5"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7545_7478"
                      x1="16"
                      y1="2.04297"
                      x2="16"
                      y2="2.28775"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop offset="1"
              stop-color="#F3F0F6"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7545_7478"
                      x1="26.9609"
                      y1="9.02205"
                      x2="26.7543"
                      y2="9.02205"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop offset="1"
              stop-color="#F3F0F6"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7545_7478"
                      x1="16"
                      y1="29.957"
                      x2="16"
                      y2="29.7474"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7545_7478"
                      x1="4.68127"
                      y1="9.00738"
                      x2="6.22275"
                      y2="9.00738"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CEC4D9" />
        <stop offset="1"
              stop-color="#CEC4D9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7545_7478"
                      x1="5.03906"
                      y1="17.8509"
                      x2="5.24686"
                      y2="17.8509"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint6_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.1296 7.18054) rotate(-90) scale(2.30293 0.723014)"
      >
        <stop stop-color="#D2C5DF" />
        <stop offset="0.204729"
              stop-color="#D2C5DF"
              stop-opacity="0.796367"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.1818 5.25418) rotate(-90) scale(2.47428 0.776809)"
      >
        <stop stop-color="#D2C5DF" />
        <stop offset="0.204729"
              stop-color="#D2C5DF"
              stop-opacity="0.796367"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.1818 4.16402) rotate(-90) scale(1.7271 0.542228)"
      >
        <stop stop-color="#D2C5DF" />
        <stop offset="0.204729"
              stop-color="#D2C5DF"
              stop-opacity="0.796367"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.9392 8.88752) rotate(-1.02303) scale(1.89107 0.593708)"
      >
        <stop stop-color="#D2C5DF" />
        <stop offset="0.204729"
              stop-color="#D2C5DF"
              stop-opacity="0.796367"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(23.6611 8.78623) scale(2.38034 0.747317)"
      >
        <stop stop-color="#D2C5DF" />
        <stop offset="0.204729"
              stop-color="#D2C5DF"
              stop-opacity="0.796367"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint11_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.0623 8.76935) scale(1.43496 0.450511)"
      >
        <stop stop-color="#D2C5DF" />
        <stop offset="0.204729"
              stop-color="#D2C5DF"
              stop-opacity="0.796367"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint12_linear_7545_7478"
                      x1="20.5391"
                      y1="8.70696"
                      x2="23.1797"
                      y2="6.06633"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CAC2CE" />
        <stop offset="1"
              stop-color="#BDB4C1"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_7545_7478"
                      x1="23.3662"
                      y1="9.2334"
                      x2="23.3662"
                      y2="8.52299"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C0ACD5" />
        <stop offset="1"
              stop-color="#C0ACD5"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_7545_7478"
                      x1="19.9201"
                      y1="4.86793"
                      x2="20.2272"
                      y2="4.86793"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint15_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.0859 8.31244) rotate(71.3377) scale(0.622578 0.240353)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint16_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.1406 8.56244) rotate(36.9314) scale(0.728125 0.2811)"
      >
        <stop stop-color="#9D9CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint17_linear_7545_7478"
                      x1="23.7735"
                      y1="5.5507"
                      x2="22.5157"
                      y2="6.82043"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.119171"
              stop-color="#DBDADC"
        />
        <stop offset="0.577307"
              stop-color="#CBC7D0"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7545_7478"
                      x1="9.03906"
                      y1="21.4922"
                      x2="18.0234"
                      y2="21.4922"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9C96A2" />
        <stop offset="1"
              stop-color="#9A95A1"
        />
      </linearGradient>
      <radialGradient id="paint19_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.8344 27.5715) rotate(-40.0074) scale(13.0302 8.0826)"
      >
        <stop stop-color="#FF9130" />
        <stop offset="1"
              stop-color="#F3633D"
        />
      </radialGradient>
      <linearGradient id="paint20_linear_7545_7478"
                      x1="16.1544"
                      y1="20.4929"
                      x2="17.087"
                      y2="21.5835"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EE9B6A" />
        <stop offset="1"
              stop-color="#EE9B6A"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint21_linear_7545_7478"
                      x1="22.8413"
                      y1="23.5661"
                      x2="21.7068"
                      y2="22.4139"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E66A62" />
        <stop offset="1"
              stop-color="#E66A62"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint22_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.6818 27.4317) rotate(-39.2242) scale(12.0339 2.691)"
      >
        <stop stop-color="#FF994D" />
        <stop offset="1"
              stop-color="#FF994D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint23_linear_7545_7478"
                      x1="11.3038"
                      y1="27.4829"
                      x2="12.7661"
                      y2="30.3734"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D8A587" />
        <stop offset="1"
              stop-color="#CE7A98"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_7545_7478"
                      x1="13.3313"
                      y1="27.8085"
                      x2="12.9517"
                      y2="28.1241"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.207411"
              stop-color="#FFC09F"
        />
        <stop offset="1"
              stop-color="#FCB196"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7545_7478"
                      x1="9.74811"
                      y1="27.2254"
                      x2="11.137"
                      y2="27.4873"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DEBCA3" />
        <stop offset="1"
              stop-color="#DEBCA3"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7545_7478"
                      x1="28.6275"
                      y1="15.1083"
                      x2="25.6434"
                      y2="17.5183"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF6153" />
        <stop offset="1"
              stop-color="#FF6154"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_7545_7478"
                      x1="23.8306"
                      y1="14.3852"
                      x2="25.7782"
                      y2="16.5746"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F1553E" />
        <stop offset="1"
              stop-color="#F1553E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint28_radial_7545_7478"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.0102 15.6715) rotate(140.636) scale(0.907664 2.06194)"
      >
        <stop offset="0.177419"
              stop-color="#FF786D"
        />
        <stop offset="1"
              stop-color="#FF786D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint29_linear_7545_7478"
                      x1="22.0405"
                      y1="16.0809"
                      x2="24.5162"
                      y2="18.8217"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C5C4CB" />
        <stop offset="1"
              stop-color="#E8DEFA"
        />
      </linearGradient>
      <linearGradient id="paint30_linear_7545_7478"
                      x1="25.8706"
                      y1="21.119"
                      x2="24.4923"
                      y2="19.4851"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C9B9E0" />
        <stop offset="1"
              stop-color="#C9B9E0"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint31_linear_7545_7478"
                      x1="10.0533"
                      y1="28.9823"
                      x2="10.6569"
                      y2="30.0204"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#461E49" />
        <stop offset="1"
              stop-color="#450F51"
        />
      </linearGradient>
      <clipPath id="clip0_7545_7478">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
